import React from 'react';
import ComboBox from '../../../../../components/ComboBox';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import PropTypes from 'prop-types';
import dataModel from '../../../../../models/DataModel';
import FormBuilder from '../../../../Forms/FormBuilder';
import ExpandableSection from '../../../../ExpandableSection';

import trashIcon from '../../../../../assets/images/trash.svg';
import './TaskCompletionStepEdit.scss';
import Input from '../../../../Input';
import Textarea from '../../../../Textarea';

// TODO: collapse this with other components under same name
export default class TaskCompletionStepEdit extends BaseComponent {

  constructor(props) {
    super(props);

    TaskCompletionStepEdit.propTypes = {
      /** Object representation for the completion step to add/edit */
      completionStep: PropTypes.object,
      /** Handler for cancelling the step add. */
      handleCancelAddCompletionStep: PropTypes.func,
      /** Handler for savung the step. */
      handleSaveCompletionStep: PropTypes.func,
      /** Handler for deleting the step. */
      handleDeleteCompletionStep: PropTypes.func,
      /** Whether drag-drop is enabled (boolean) */
      enableDragDrop: PropTypes.bool,

      /** Drag-drop handlers */
      handleDragging: PropTypes.func,
      handleDropping: PropTypes.func,
      handleDragCancel: PropTypes.func,
    };

    this.completionCriteriaTypes = [
      { type: 'none', name: 'Check-off' },
      { type: 'doc', name: 'Document (.doc/.docx)' },
      { type: 'form', name: 'Form' },
      { type: 'inspection', name: 'Inspection' },
      { type: 'pdf', name: 'PDF (.pdf)' },
      { type: 'jpg', name: 'Photographs (.jpg/.png/.webp)' },
      { type: 'xls', name: 'Spreadsheet (.xls/.xlsx/.xlsm)' },
      { type: 'mp4', name: 'Video (.mp4/.mov)' },
      { type: 'Other', name: 'Other' },
    ];

    // create a new object to represent the edited completion step
    const editCompletionStep = props.completionStep ? Object.assign({}, props.completionStep) : {};

    this.state = { 
      editCompletionStep: editCompletionStep,
      readyForUpdate: false,
      readyForCancel: false,
      expanded: this.props.newCompletionStep,
    };

    this.checkIfReadyForUpdate = this.checkIfReadyForUpdate.bind(this);
    this.getCompletionStepType = this.getCompletionStepType.bind(this);
    this.saveCompletionStep = this.saveCompletionStep.bind(this);
    this.cancelCompletionStep = this.cancelCompletionStep.bind(this);
    this.getInstructionsPlaceholder = this.getInstructionsPlaceholder.bind(this);
    this.handleFormUpdate = this.handleFormUpdate.bind(this);
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.completionStep != prevProps.completionStep && this.props.completionStep) {
      for (let key in this.state.editCompletionStep) {
        if (key && key != 'order') {
          if (this.state.editCompletionStep[key] != prevProps.completionStep[key]) {
            this.props.completionStep[key] = this.state.editCompletionStep[key];
          }
        }
      }
      this.setState({ editCompletionStep: Object.assign({}, this.props.completionStep) });
    }
  }

  checkIfReadyForUpdate(editedCompletionStep) {
    let readyForUpdate = !!(editedCompletionStep.completion_type && editedCompletionStep.name);
    // Inspection steps require instructions
    if (editedCompletionStep.completion_type == 'inspection') {
      readyForUpdate = !!(editedCompletionStep.instructions && editedCompletionStep.name);
    }
    else if (editedCompletionStep.completion_type == 'form') {
      readyForUpdate = !!(editedCompletionStep.form_fields && editedCompletionStep.form_fields.length && editedCompletionStep.name);
    }
    this.setState({ readyForUpdate }); 
  }

  handleExpansion(isExpanded) {
    this.setState({ expanded: isExpanded });
  }

  getCompletionStepType(editedCompletionStep) {
    switch (editedCompletionStep.completion_type) {
    case 'boolean':
      return { type: 'none', name: 'Check-off' };
    case 'inspection':
      return { type: 'inspection', name: 'Inspection' };
    case 'form':
      return { type: 'form', name: 'Form' };
    case null:
    case undefined:
      return null;
    default:
      const type = editedCompletionStep.requested_file_type ||  'Other';
      return this.completionCriteriaTypes.find((typeObject) => typeObject.type == type);
    }
  }

  /** EVENT HANDLERS */
  handleChangeTextField(e, fieldName) {
    let editedCompletionStep = Object.assign({}, this.state.editCompletionStep);
    editedCompletionStep[fieldName] = e.target.value;
    this.checkIfReadyForUpdate(editedCompletionStep);
    this.setState({ editCompletionStep: editedCompletionStep, readyForCancel: true });
    dataModel.dataChanged = true;
  }

  handleCheckPhotoEvidence(e, fieldName){
    let editedCompletionStep = Object.assign({}, this.state.editCompletionStep);
    editedCompletionStep[fieldName] = e.currentTarget.checked;
    this.checkIfReadyForUpdate(editedCompletionStep);
    this.setState({ editCompletionStep: editedCompletionStep, readyForCancel: true });
    dataModel.dataChanged = true;
  }
  
  handleChangeType(type) {
    let editedCompletionStep = Object.assign({}, this.state.editCompletionStep);
    if (type == 'none') {
      editedCompletionStep.completion_type = 'boolean';  
      editedCompletionStep.requested_file_type = null;
    }
    else if (type == 'form') {
      editedCompletionStep.completion_type = type;
      editedCompletionStep.requested_file_type = null;
    }
    else if (type == 'inspection') {
      editedCompletionStep.completion_type = type;
      editedCompletionStep.requested_file_type = 'jpg';
    }
    else  {
      editedCompletionStep.completion_type = 'file_upload';
      editedCompletionStep.requested_file_type = type;
    }
    this.checkIfReadyForUpdate(editedCompletionStep);
    this.setState({ editCompletionStep: editedCompletionStep, readyForCancel: true, expanded: true });
    dataModel.dataChanged = true;
  }

  handleFormUpdate(updatedFormFields) {
    const { editCompletionStep } = this.state;
    editCompletionStep.form_fields = updatedFormFields;
    this.setState({ editCompletionStep });
    this.checkIfReadyForUpdate(editCompletionStep);
  }

  saveCompletionStep() {
    if (this.state.readyForUpdate) {
      this.props.handleSaveCompletionStep(this.state.editCompletionStep);
      this.setState({ readyForUpdate: false, readyForCancel: false });
      dataModel.dataChanged = false;
    }
  }

  cancelCompletionStep(e) {
    if (this.props.newCompletionStep) {
      if (this.props.handleCancelAddCompletionStep) {
        this.props.handleCancelAddCompletionStep();
      }
    }
  }

  handleCancelEditCompletionStep() {
    const { completionStep } = this.props;
    let { editCompletionStep } = this.state;

    editCompletionStep.name = completionStep.name;
    editCompletionStep.attachment_required = completionStep.attachment_required;
    editCompletionStep.completion_type = completionStep.completion_type;
    editCompletionStep.requested_file_type = completionStep.requested_file_type;
    editCompletionStep.instructions = completionStep.instructions;

    this.setState({ editCompletionStep, readyForUpdate: false, readyForCancel: false });
  }

  getInstructionsPlaceholder(type) {
    switch(type) {
    case 'inspection':
      return 'You must enter an inspection question';
    case 'form':
      return 'Enter Form Instructions';
    default: 
      return 'Enter Completion Step Instructions';
    }
  }

  render() {
    let saveAndCancelButtons, deleteButton, dragHandle, formSection, inspectionChecks;
    let deleteButtonContainerClass = '';
    let adding = false;
    const { editCompletionStep, expanded } = this.state;

    inspectionChecks = (
      <div className={`task-step-edit__photo-evidence-and-remediation ${!this.state.readyForCancel ? 'edit' : ''}`}>
        <div>
          <input type="checkbox" checked={editCompletionStep && editCompletionStep.attachment_required} onChange={(e) => this.handleCheckPhotoEvidence(e, 'attachment_required')}/>
          <label>Require photo evidence of inspection</label>
        </div>
      </div>
    );

    if(!this.props.completionStep) {
      adding = true;
      saveAndCancelButtons = (
        <div className="task-step-edit__save-and-cancel">
          <button className="cancel-button" onClick={this.cancelCompletionStep}>CANCEL</button>
          <button className={ 'save-button' + (this.state.readyForUpdate ? ' save-button--active' : '') } onClick={this.saveCompletionStep}>ADD</button>
        </div>
      );
    }
    else {
      deleteButton = (
        <img className="remove-button" src={trashIcon} onClick={ () => this.props.handleDeleteCompletionStep(editCompletionStep) } alt="remove-button" />
      );
      deleteButtonContainerClass = ' file-type-selector--with-delete';
      saveAndCancelButtons = (
        <div className="task-step-edit__save-and-cancel">
          { this.state.readyForCancel && <button className="cancel-button" onClick={this.handleCancelEditCompletionStep}>CANCEL</button>}
          <button className={ 'save-button' + (this.state.readyForUpdate ? ' save-button--active' : '') } onClick={this.saveCompletionStep}>SAVE</button>
        </div>
      );
      
    }
    if (this.props.enableDragDrop) {
      dragHandle = (
        <div className="drag-handle"
          onMouseDown={this.handleMouseDown}
          onMouseUp={this.handleMouseUp}
          onMouseMove={this.handleMouseMove}>
        </div>
      );
    }
    const currentStepType = this.getCompletionStepType(editCompletionStep);
    const currentStepTypeString = currentStepType ? currentStepType.type : null;
    const isInspectionType = currentStepTypeString == 'inspection';
    const isFormType = currentStepTypeString == 'form';
    if (isFormType) {
      formSection = (
        <FormBuilder 
          completionStep={editCompletionStep} 
          handleFormUpdate={this.handleFormUpdate}
          handleMarkInvalid={() => this.setState({ readyForUpdate: false })}
        />
      );
    }

    let footer = null;
    if (expanded) {
      footer =  (
        <div >
          <Textarea
            tabIndex="3" 
            className={'task-step-edit__instructions-input' + (isInspectionType ? ' task-step-edit__instructions-input--inspection' : '') + (isFormType ? ' task-step-edit__instructions-input--form' : '')}
            value={editCompletionStep.instructions || ''}
            onChange={ (e) => this.handleChangeTextField(e, 'instructions') } 
            placeholder={this.getInstructionsPlaceholder(currentStepTypeString)}
          />
          {formSection}
          <div className="task-step-edit__buttons">
            {isInspectionType && inspectionChecks}
            {saveAndCancelButtons}
          </div>
        </div>
      );

    }
    
    const status = { text: 'Not Started', css: 'not-started' };
    
    let nameType =
      expanded ? (
        <div className="label">
          NAME
          <Input 
            tabIndex="1" 
            autoFocus 
            className="name-field" 
            value={editCompletionStep.name || ''}
            onChange={(e) => this.handleChangeTextField(e, 'name')} 
            placeholder={currentStepTypeString == 'form' ? 'Enter Form Name' : 'Enter Completion Step Name'} 
            ref={(c) => this._nameField = c} 
          />
        </div>
      ) :
        (
          <div className={'completion-step-info ' + status.css}>
            <div className="step-title">
              {editCompletionStep.name ? editCompletionStep.name.toUpperCase() : ''}
            </div>
            <div className={'step-status ' + status.css}>{status.text}</div>
          </div>
        );

    return (
      <div className={'task-step-edit enabled' + (adding ? ' adding' : '') + (expanded ? ' expanded' : ' contracted')}
        id={this.props.id} ref={element => {
          this.cardElement = element;
        }}
        >
        {dragHandle}
        <div className="task-step-edit__type-and-name">
          {nameType}
          <div className="label">TYPE
            <div className={'file-type-selector' + deleteButtonContainerClass}>
              <ComboBox 
                adjustHeight={true}
                currentOption={currentStepType}
                defaultText="—Type—"
                displayFontStyle={{ fontSize: '12px' }} 
                handleSelection={this.handleChangeType}
                hasBorder={false} 
                id="customFieldTypePicker"
                key={'completionCriteriaTypePicker'}
                options={this.completionCriteriaTypes} 
                underlined={false} 
                width={234}
                tabIndex={'2'}
                noFocus={true}
                />
              {deleteButton}
            </div>
          </div>
        </div>
        <ExpandableSection onExpand={this.handleExpansion} initiallyExpanded={expanded}>
          {footer}
        </ExpandableSection>
        <div className='edit-separator' />
      </div>
    );
  }

  /** DRAG&DROP FUNCTIONS */
  handlePrepareDrag(xPos, yPos) {
    this.dragElement = this.cardElement;
    this.startX = xPos;
    this.startY = yPos;
  }

  handleStartDrag(element) {
    if (
      !this.dragging &&
      this.dragElement &&
      this.dragElement == element &&
      !this.dragObject
    ) {
      this.dragging = true;
      let bodyElement = document.body;
      // if (this.props.dragParentId) {
      //   bodyElement = document.getElementById(this.props.dragParentId)
      // }
      this.dragObject = element.cloneNode(true);
      this.dragObject.style.position = 'absolute';
      this.dragObject.style.transform = 'rotate(-10deg)';
      this.dragObject.style.zIndex = 1000;
      this.dragObject.style.opacity = 0.8;
      const bodyRect = bodyElement.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      this.xPos = elementRect.left - bodyRect.left;
      this.yPos = elementRect.top - bodyRect.top;
      this.yOffset = this.startY - this.yPos;
      this.dragObject.style.top = this.yPos + 'px';
      this.dragObject.style.left = this.xPos + 'px';
      bodyElement.addEventListener('mousemove', this.handleDragging);
      bodyElement.addEventListener('mouseup', this.handleEndDragging);
      bodyElement.appendChild(this.dragObject);
    }
  }

  handleDragging(e) {
    let top = e.clientY - this.yOffset;

    this.dragObject.style.top = top + 'px';
    if (this.props.handleDragging) {
      this.props.handleDragging(this.state.editCompletionStep, this.xPos, top);
    }
  }

  handleEndDragging(e) {
    this.dragging = false;
    let bodyElement = document.body;
    bodyElement.removeEventListener('mousemove', this.handleDragging);
    bodyElement.removeEventListener('mouseup', this.handleEndDragging);
    bodyElement.removeChild(this.dragObject);
    this.dragElement = null;
    if (this.props.handleDropping) {
      this.dragObject = null;
      let top = e.clientY - this.yOffset;
      this.props.handleDropping(this.state.editCompletionStep, this.xPos, top);
    }
  }

  handleMouseDown(e) {
    e = this.fixupMouse(e);
    if (e.which == 1) {
      if (this.props.handleDragging) {
        this.handlePrepareDrag(e.clientX, e.clientY);
        document.body.classList.add('no-select');
      }
    }
  }

  handleMouseUp(e) {
    this.dragElement = null;
    document.body.classList.remove('no-select');
  }

  handleMouseMove(e) {
    e = this.fixupMouse(e);
    if (this.props.handleDragging) {
      if (!this.dragging && e.which == 1) {
        if (
          (this.startX && Math.abs(this.startX - e.clientX) > 5) ||
          (this.startY && Math.abs(this.startY - e.clientY) > 5)
        ) {
          this.handleStartDrag(this.cardElement);
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskCompletionStepsContainer/TaskCompletionSteps/TaskCompletionStepEdit/index.js